export function stringToColor(string: string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `ff${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */
  color = "#60" + color.substring(2, 6);
  return color;
}

export function getAcronym(data: string) {
  //console.log(data);
  return data
    .split(" ")
    .map((i) => i.charAt(0).toUpperCase())
    .join("");
}

export function toShortNumber(n: number, s?: string) {
  if (s === "comma") {
    return n.toLocaleString();
  }
  return Intl.NumberFormat("en-GB", {
    notation: "compact",
    compactDisplay: "short",
  }).format(n);
}

export const rangeToString = (min: number, max: number) => {
  return "[" + min.toString() + "," + max.toString() + "]";
};

export const roundNumber = (num: any) => {
  //console.log(num);
  return Array.isArray(num)
    ? num.map(
        (item: any) =>
          Math.round((parseFloat(item) + Number.EPSILON) * 100) / 100
      )
    : Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100;
};

export const capitalize = (s: string) => {
  const s1 = s[0];
  const s_left = s.slice(1);
  return s1.toUpperCase() + s_left.toLowerCase();
};

export const underscoreToCap = (s: string) => {
  const words = s.split("_");
  const capWords = words.map((w) => (w === "of" ? w : capitalize(w)));
  let result = capWords.join(" ");
  if (result === "Yes" || result === "No" || result === "Result") {
    result += " Votes";
  } else if (result === "Proposal Name") {
    result = "Proposal";
  } else if (result === "Fund Id") {
    result = "Fund";
  } else if (result === "Challenge Name") {
    result = "Challenge";
  }
  return result;
};

export const titleStyler = () => {
  let width = document.body.clientWidth;
  let axisTitleStyle = {
    color: "#000000",
    fontWeight: "500",
    fontSize: "16px",
  };
  let chartTitleStyle = {
    color: "#000000",
    fontWeight: "500",
    fontSize: "20px",
  };
  let markerSize = [6, 6, 6, 0];
  let markerSizewDecisonB = [6, 6, 0, 0, 0, 0, 0, 0];
  let axisLabelStyle = { fontSize: "12px", fontWeight: 400 };

  if (width <= 430) {
    axisTitleStyle = {
      color: "#000000",
      fontWeight: "350",
      fontSize: "12px",
    };
    chartTitleStyle = {
      color: "#000000",
      fontWeight: "400",
      fontSize: "16px",
    };
    markerSize = [3, 3, 3, 0];
    markerSizewDecisonB = [3, 3, 0];
    axisLabelStyle = { fontSize: "11px", fontWeight: 320 };
  }
  return {
    axisTitleStyle: axisTitleStyle,
    chartTitleStyle: chartTitleStyle,
    markerSize: markerSize,
    axisLabelStyle: axisLabelStyle,
    markerSizewDecisonB: markerSizewDecisonB,
  };
};

export const tickAmount = (count: number) => {
  let tickAmount = count / 2;
  let width = document.body.clientWidth;
  if (width <= 500) {
    tickAmount = count / 4;
  }
  return tickAmount < 15 ? tickAmount : 15;
};

export const isSmallScreen = () => {
  let smallScreen: boolean = false;
  let width = document.body.clientWidth;
  if (width <= 500) {
    smallScreen = true;
  }
  return smallScreen;
};

export const redgreenscale = [
  {
    from: -0.1,
    to: 0.1,
    color: "#ff0e00",
  },
  {
    from: -0.25,
    to: -0.1,
    color: "#ff7700",
  },
  {
    from: 0.1,
    to: 0.25,
    color: "#ff7700",
  },
  {
    from: -0.5,
    to: -0.25,
    color: "#ffc000",
  },
  {
    from: 0.25,
    to: 0.5,
    color: "#ffc000",
  },
  {
    from: -0.75,
    to: -0.5,
    color: "#c1ff00",
  },
  {
    from: 0.5,
    to: 0.75,
    color: "#c1ff00",
  },
  {
    from: Math.abs(0.75),
    to: Math.abs(0.99),
    color: "#78ff24",
  },
  {
    from: Math.abs(0.99),
    to: Math.abs(1),
    color: "#00ff00",
  },
];

export const divergingscale = [
  {
    from: -1,
    to: -0.75,
    color: "#b26e3a",
  },
  {
    from: -0.75,
    to: -0.2,
    color: "#fe9c52",
  },
  {
    from: -0.2,
    to: -0.05,
    color: "#ffceaa",
  },
  // {
  //   from: -0.25,
  //   to: -0.1,
  //   color: "#ffceaa",
  // },
  {
    from: -0.05,
    to: 0.05,
    color: "#dddddd",
  },
  {
    from: 0.05,
    to: 0.2,
    color: "#9ecbec",
  },
  {
    from: 0.2,
    to: 0.75,
    color: "#3c97da",
  },

  {
    from: 0.75,
    to: 1,
    color: "#2b6998",
  },
];

export const heatMapDataLabelStyler = () => {
  let width = document.body.clientWidth;
  let dataLabelStyle = {
    fontSize: "14px",
    fontWeight: "bold",
    colors: ["#fff"],
  };

  if (width <= 600) {
    dataLabelStyle = {
      fontSize: "12px",
      fontWeight: "350",
      colors: ["#fff"],
    };
  }

  if (width <= 420) {
    dataLabelStyle = {
      fontSize: "9px",
      fontWeight: "300",
      colors: ["#fff"],
    };
  }
  return dataLabelStyle;
};

export default function getMonthName(val: number) {
  const monthArr = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  return monthArr[val - 1];
}

export function camelToTitle(str: String, addOn: string = "") {
  str += addOn;
  const words = str.match(/[A-Z]?[a-z]+/g);
  if (!words) return "";
  return words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
